// src/pages/admin/AdminLayout.tsx
import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AdminNavbar from '../../pages/admin/AdminNavbar';

const AdminLayout: React.FC = () => {
  const location = useLocation();
  const { t, i18n } = useTranslation();

  // 动态设置浏览器标签页标题（与医生端一致的做法）
  useEffect(() => {
    const base = 'Melodis Clinic';
    const p = location.pathname;

    const pageTitle =
      (p.startsWith('/admin/dashboard') && t('admin.tab_dashboard')) ||
      (p.startsWith('/admin/reservations') && t('admin.tab_reservations')) ||
      (p.startsWith('/admin/users') && t('admin.tab_users')) ||
      (p.startsWith('/admin/doctors') && t('admin.tab_doctors')) ||
      (p.startsWith('/admin/medicines') && t('admin.tab_medicines')) ||
      (p.startsWith('/admin/schedule') && t('admin.tab_schedule')) ||
      (p.startsWith('/admin/settings') && t('admin.tab_settings')) ||
      t('admin.title'); // 兜底

    document.title = `${pageTitle} | ${base}`;
  }, [location.pathname, i18n.language, t]);

  return (
    <div
      className="min-h-screen bg-background bg-gradient-hero text-base"
    >
      <AdminNavbar />
      <div className="px-4 sm:px-6 mt-6 w-full">
        <Outlet />
      </div>
    </div>
  );
};

export default AdminLayout;
